import { inject, Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutSingleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { Customer, CustomerListConfigService, MetadataService } from 'gung-standard';
import { JeevesCustomerListCardComponent } from '../../components/jeeves-customer-list-card/jeeves-customer-list-card.component';

@Injectable({
  providedIn: 'root'
})
export class JeevesCustomerListConfigService extends CustomerListConfigService {
  protected metadataService = inject(MetadataService);

  getFilters(): ConfigBaseFilter<Customer>[] {
    const filters = super.getFilters();
    filters.push(new CustomerSalespersonFilter(this.metadataService));
    return filters;
  }

  getSearchTerms(item: Customer): string[] {
    const superTerms = super.getSearchTerms(item);
    if (item.extra.fr && item.extra.fr.ftgpostadr3) {
      return superTerms.concat([item.extra.fr.ftgpostadr3]);
    }
    return superTerms;
  }

  getLayouts(): ListLayout<Customer>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => JeevesCustomerListCardComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Customer list'
      }
    ];
  }
}

// MARK: CustomerSalespersonFilter
export class CustomerSalespersonFilter extends SimpleConfigBaseFilter<Customer> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'SALESPERSON';
  }
  getOptionIds(item: Customer): string[] {
    const metadataValue = this.metadataService.getMetadataValue('salj', 'saljarenamn', item.extra.kus.saljare);
    if (metadataValue == null) {
      return [];
    } else {
      return [metadataValue];
    }
  }

  getOptionName(key: string): string {
    return key;
  }
}